module.exports = __webpack_public_path__ + "img/06.11f14882.png";